<script lang="ts">
  import { appTheme } from '../lib/stores';
  const BASE = '/api';

  let authError = $state('');
  const fundEntry = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('fund') === '1';

  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const err = params.get('auth_error');
    if (err === 'personal_email') authError = 'Dealton requires a work email to connect with your company\'s email and calendar. Personal accounts (Gmail, Yahoo, Outlook, etc.) cannot be used. Please sign in with your work account.';
    else if (err === 'unauthorized') authError = 'Your account is not authorised to access this app.';
    else if (err === 'missing_permissions') authError = 'Please grant all requested permissions (email and calendar access) to use the app. Try signing in again and check all the boxes.';
    else if (err === 'readonly_required') authError = 'A read-only mailbox grant is required for Fund early access. Please reconnect and approve only the requested read permission.';
    else if (err) authError = 'Sign-in failed. Please try again.';
  }

  function signIn() {
    window.location.href = `${BASE}/auth/login${fundEntry ? '?fund=true' : ''}`;
  }
</script>

<div class="login-wrap">
  <div class="login-glow"></div>
  <div class="login-card">
    <div class="login-header">
      <img src="/logo-dark.svg" alt="Dealton" class="login-logo-img" />
      <div class="login-badge"><span class="login-dot"></span> {fundEntry ? 'Investor Relations early access' : 'Your full-cycle AI sales partner'}</div>
      <p class="login-sub">{fundEntry ? 'Complete onboarding, connect your mailbox with read-only access, and help us prepare your IR workspace. The product opens in about two weeks.' : 'Your Dealton knows every deal, writes every email, and co-leads every call — so you can focus on closing.'}</p>
    </div>

    <div class="login-body">
      {#if authError}
        <div class="login-error">{authError}</div>
      {/if}

      <button class="google-btn" onclick={signIn}>
        <svg width="16" height="16" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">
          <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
          <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/>
          <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
          <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
        </svg>
        Login with Google
      </button>

      <button class="microsoft-btn" onclick={() => window.location.href = `${BASE}/auth/microsoft/login${fundEntry ? '?fund=true' : ''}`}>
        <svg width="16" height="16" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">
          <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
          <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
          <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
          <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
        </svg>
        Login with Microsoft
      </button>

      <p class="login-hint">{fundEntry ? 'Read-only mail access helps build shared LP context and review-only drafts. Dealton never sends email for you.' : 'Sign in with your work email account'}</p>
      <a href="https://dealton.ai" class="login-learn-more">Learn more about Dealton</a>
      <div class="login-legal">
        <a href="https://dealton.ai/privacy.html" target="_blank" rel="noopener">Privacy Policy</a>
        <span class="login-legal-sep"></span>
        <a href="https://dealton.ai/terms.html" target="_blank" rel="noopener">Terms of Use</a>
      </div>
    </div>
  </div>
</div>

<style>
  .login-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: #0c0a0d;
    position: relative;
    overflow: hidden;
  }

  .login-glow {
    position: absolute;
    top: -200px;
    left: 50%;
    transform: translateX(-50%);
    width: 700px;
    height: 700px;
    background: radial-gradient(circle, rgba(232, 85, 58, 0.08) 0%, transparent 65%);
    pointer-events: none;
  }

  .login-card {
    background: #141216;
    border: 1px solid #2a262e;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
    width: 420px;
    max-width: 92vw;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }

  .login-header {
    padding: 36px 32px 28px;
    text-align: center;
    border-bottom: 1px solid #2a262e;
  }

  .login-logo-img {
    height: 36px;
    margin-bottom: 16px;
  }

  .login-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 100px;
    border: 1px solid #2a262e;
    background: #1c191f;
    font-size: 12px;
    color: #8a8490;
    margin-bottom: 16px;
  }

  .login-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #22c55e;
    animation: pulse-dot 2s infinite;
  }

  @keyframes pulse-dot {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }

  .login-sub {
    font-size: 13px;
    color: #8a8490;
    line-height: 1.5;
    max-width: 320px;
    margin: 0 auto;
    text-align: center;
  }

  .login-body {
    padding: 24px 32px 28px;
  }

  .login-hint {
    font-size: 11px;
    color: #5a5660;
    margin-top: 12px;
    text-align: center;
  }

  .login-error {
    background: rgba(248, 113, 113, 0.1);
    color: #f87171;
    border: 1px solid rgba(248, 113, 113, 0.25);
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 12px;
    margin-bottom: 16px;
  }

  .google-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    justify-content: center;
    background: #1c191f;
    color: #e0dce3;
    border: 1px solid #2a262e;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .google-btn:hover {
    background: #2a262e;
    border-color: #3a363e;
    transform: translateY(-1px);
  }

  .microsoft-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    justify-content: center;
    background: #1c191f;
    color: #e0dce3;
    border: 1px solid #2a262e;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
    margin-top: 10px;
  }

  .microsoft-btn:hover {
    background: #2a262e;
    border-color: #3a363e;
    transform: translateY(-1px);
  }

  .login-learn-more {
    display: block;
    text-align: center;
    margin-top: 16px;
    font-size: 12px;
    color: #8a8490;
    text-decoration: none;
    transition: color 0.15s;
  }
  .login-learn-more:hover { color: #e8553a; }

  .login-legal {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 12px;
  }
  .login-legal a {
    font-size: 11px;
    color: #5a5660;
    text-decoration: none;
    transition: color 0.15s;
  }
  .login-legal a:hover { color: #8a8490; }
  .login-legal-sep {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #3a363e;
  }

  @media (max-width: 480px) {
    .login-card { border-radius: 0; border: none; width: 100%; max-width: 100%; }
    .login-header { padding: 28px 24px 20px; }
    .login-body { padding: 20px 24px 24px; }
  }
</style>
